export default {
      id: "phone-usage",
      viewBox: "0 0 19 30",
      url: __webpack_public_path__ + "app/svg/sprite.svg#phone",
      toString: function () {
        return this.url;
      }
    }